import { StyleSheet } from 'react-native';
import Theme from 'Theme/index';
import type { StylesMap } from 'types';
import { Device } from 'DeviceUtils';

export const WEB_WIDTH = 1280;
const MENU_PADDING_TOP = 33;
export const POPUP_WIDTH = 200;
export const POPUP_TRIANGLE_OFFSET = 12;
export const POPUP_RIGHT_OFFSET = 20;
export const POPUP_TOP_OFFSET = 200;
export const TOP_BAR_HEIGHT = 84;
export const TOP_MARGIN_TABLET_OFFSET = 60;
export const TOP_BAR_ITEMS_HEIGHT = 72;
export const TOP_BAR_HEGHT_CONST = 30;
export const TOP_BAR_TOTAL_HEIGHT = TOP_BAR_HEIGHT + TOP_BAR_ITEMS_HEIGHT;
export const MINIMISED_OFFSET = 79;
export const DETAIL_HEADER_HEIGHT = 64;

const baseStyles: StylesMap = {
    container: {
        alignItems: 'center',
        paddingTop: Device.isTablet ? null : MENU_PADDING_TOP,
        paddingHorizontal: 14
    },
    authContainer: {
        alignSelf: 'stretch',
        marginBottom: 15
    },
    registerTextsContainer: {
        marginBottom: 27
    },
    text: {
        fontFamily: Theme.regularFont,
        color: Theme.secondaryTextColor,
        fontSize: 19,
        textAlign: 'center'
    },
    registerLink: {
        fontSize: 19
    },
    email: {
        fontFamily: Theme.regularFont,
        color: Theme.secondaryTextColor,
        fontSize: 19,
        marginVertical: 8,
        marginStart: 13
    },
    logOutButtonContainer: {
        alignSelf: 'stretch',
        marginLeft: 62,
        marginTop: 15
    },
    logOutButton: {
        color: Theme.primaryActiveColor,
        alignItems: 'flex-start',
        fontSize: 22
    },
    loginButton: {
        alignSelf: 'stretch',
        marginBottom: 15
    },
    subMenuDivider: {
        marginTop: 18,
        marginBottom: 14
    },
    closeMenuIcon: {
        alignSelf: 'flex-end',
        marginBottom: Theme.BU
    }
};

const webStyles: StylesMap = {
    container: {
        backgroundColor: Theme.primaryBackgroundColor,
        overflow: 'visible',
        zIndex: 3,
        position: 'absolute',
        width: '100%',
        transition: 'transform .16s linear'
    },
    topBar: {
        alignSelf: 'stretch',
        height: TOP_BAR_HEIGHT,
        backgroundColor: Theme.primaryButtonBackgroundColor
    },
    contentContainer: {
        flex: 1,
        flexDirection: 'row',
        width: WEB_WIDTH,
        alignSelf: 'center',
        paddingHorizontal: Theme.primaryMargin,
        height: '100%'
    },
    logo: {
        width: 84,
        height: '100%'
    },
    topTextContainer: {
        flex: 1,
        height: '100%',
        justifyContent: 'center'
    },
    topText: {
        fontSize: 12,
        fontWeight: '600',
        textAlign: 'right',
        color: Theme.primaryTextColor
    },
    popup: {
        position: 'absolute',
        backgroundColor: 'rgba(255,255,255,0.9)',
        borderRadius: 3,
        minWidth: POPUP_WIDTH,
        minHeight: 70,
        zIndex: 99
    },
    popupTriangle: {
        position: 'absolute',
        top: -10,
        right: POPUP_TRIANGLE_OFFSET,
        width: 10,
        height: 10,
        borderLeftWidth: 10,
        borderLeftColor: 'transparent',
        borderRightWidth: 10,
        borderRightColor: 'transparent',
        borderBottomWidth: 10,
        borderBottomColor: 'rgba(255,255,255,0.9)'
    },
    popupText: {
        width: '100%',
        color: Theme.placeholderTextColor,
        padding: 15,
        paddingHorizontal: 25,
        borderBottomColor: '#A4A4A4',
        borderBottomWidth: 1
    },
    logOutButton: {
        padding: 15,
        paddingHorizontal: 25
    },
    centerElement: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        height: TOP_BAR_ITEMS_HEIGHT
    },
    menuContainer: {
        position: 'relative',
        flexDirection: 'row',
        alignSelf: 'center',
        paddingHorizontal: Theme.primaryMargin
    },
    logoContainer: {
        width: 180,
        justifyContent: 'center'
    },
    logoPressContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    iconLogoInMenu: {
        width: 21.5,
        height: 21.5,
        marginRight: 10
    },
    appTitleInMenu: {
        color: Theme.secondaryTextColor,
        fontSize: 20
    },
    rightMenuOptionsContainer: {
        width: 350,
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexDirection: 'row'
    },
    iconButtons: {
        height: '100%',
        justifyContent: 'center',
        marginLeft: 23,
        marginRight: 24,
        borderBottomWidth: 2
    },
    loginButtonWeb: {
        height: '100%',
        justifyContent: 'center'
    },
    iconSize: {
        width: 20,
        height: 20
    }
};

export default StyleSheet.create(Device.isWeb ? webStyles : baseStyles);

// Musn't be in stylesheet.create
// because react native doesnt support position fixed
export const popupOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1
};

export const userIconStyle = {
    width: 20,
    height: 20
};

export const loginButtonStyle = {
    button: {
        paddingHorizontal: 20,
        marginLeft: 30,
        alignSelf: 'flex-start',
        minWidth: 0
    }
};
